import PollVisualization from './PollVisualization.container';

export default PollVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/pollvisualization/index.js